import { StoreLocation02Icon, Wallet03Icon } from 'hugeicons-react';
import { motion } from 'motion/react'; // eslint-disable-line
import PropTypes from 'prop-types';
import Badge from '@components/ui/Badge.component.jsx';
import GlassCard from '@components/ui/GlassCard/GlassCard';

const variants = {
  visible: { opacity: 1 },
  hidden: { opacity: 0.3 },
};

export default function GlassTicket({ store, price }) {
  return (
    <motion.div
      variants={variants}
      initial="hidden"
      whileInView="visible"
      exit="hidden"
      transition={{ duration: 0.3, ease: 'easeInOut' }}
    >
      <GlassCard className="flex flex-row justify-between items-center rounded-2xl p-4 shadow-lg">
        <Badge
          className={'text-event-text text-base'}
          variant={'icon-only-rounded'}
          icon={
            <StoreLocation02Icon
              size={18}
              strokeWidth={2}
              className="text-event-text"
            />
          }
          text={store}
        />
        <Badge
          variant={'full'}
          icon={
            <Wallet03Icon
              strokeWidth={2}
              size={18}
              className={'text-event-text'}
            />
          }
          text={`${price} MDL`}
        />
      </GlassCard>
    </motion.div>
  );
}
GlassTicket.propTypes = {
  store: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
};

GlassTicket.defaultProps = {
  store: 'Store',
  price: 'Price',
};
